module.exports = __webpack_public_path__ + "static/img/service_content3_img.d615286.png";